import { useEffect } from 'react';

import { useAuth } from '@/hooks/useAuth';
import { isPostHogEnabled, posthog, registerBaseSuperProperties } from '@/lib/posthog';

export function PostHogIdentitySync() {
  const { user } = useAuth();

  useEffect(() => {
    if (!isPostHogEnabled) return;

    if (!user) {
      posthog.reset();
      // reset() clears all super-properties; re-register so anonymous and
      // post-logout events stay attributable to dev/prod and automation runs.
      registerBaseSuperProperties();
      return;
    }

    if (user.impersonation) {
      posthog.register({
        impersonating: true,
        impersonationTarget: user.email,
      });
      return;
    }

    posthog.unregister('impersonating');
    posthog.unregister('impersonationTarget');

    posthog.identify(user.id, {
      email: user.email,
      displayName: user.displayName,
      role: user.role,
      department: user.department,
      isBootstrapAdmin: user.isBootstrapAdmin,
    });
  }, [user]);

  return null;
}
